import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '@env/environment';
import { Logger } from '../logger.service';
import { Router } from '@angular/router';
import { ErrorService } from '@app/pages/error/error.service';

const log = new Logger('ErrorHandlerInterceptor');

/**
 * Adds a default error handler to all requests.
 */
@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private errorService: ErrorService,
  ) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.errorService.setError('');
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.error?.code) {
          return throwError(() => error);
        }

        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          // Client-side error
          errorMessage = `Client-side error: ${error.error.message}`;
        }

        // Redirect to an error page or login if needed
        if (error.status === 401 && error.error.message == 'Refresh Token Expired') {
          this.router.navigate(['/']);
        } else if (error.status === 403) {
          this.router.navigate(['/']);
        } else if (error.status === 0) {
          errorMessage = 'Network error: Unable to connect to the server';
        } else {
          errorMessage = 'Error:' + error.error.detail;
        }
       // this.errorService.setError('Error:Please try again.');
        //throw new Error("Test");
        return throwError(() => errorMessage);
      }),
    );
  }
}
